/*
 * VALIZ · oferta del tarjetero en el carro. El botón agrega el tarjetero (y el
 * strap de regalo, si hay) en UNA sola llamada y vuelve a dibujar el carro lateral
 * con la misma ruta que usa el tema al agregar un producto (cart-drawer.renderContents).
 * Si el strap ya no alcanza (Shopify rechaza todo el pedido), reintenta solo con el
 * tarjetero. En la página de carro (sin carro lateral) recarga la página.
 */
(function () {
  if (window.ValizOferta) return;
  window.ValizOferta = true;

  var REGALO = 'Con tu tarjetero';

  function agregar(items, secciones) {
    var cuerpo = { items: items };
    if (secciones) cuerpo.sections = secciones;
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    }).then(function (r) {
      return r.json().then(function (j) {
        return { ok: r.ok, datos: j };
      });
    });
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest('[data-valiz-oferta]');
    if (!boton || boton.disabled) return;
    e.preventDefault();
    var caja = boton.closest('[data-valiz-oferta-caja]');
    var error = caja && caja.querySelector('[data-valiz-oferta-error]');
    var texto = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Agregando…';
    if (error) error.hidden = true;

    var tarjetero = { id: Number(boton.dataset.tarjetero), quantity: 1 };
    var strap = boton.dataset.strap ? { id: Number(boton.dataset.strap), quantity: 1, properties: { Regalo: REGALO } } : null;
    var drawer = document.querySelector('cart-drawer');
    var secciones = drawer ? 'cart-drawer,cart-icon-bubble' : null;

    agregar(strap ? [tarjetero, strap] : [tarjetero], secciones)
      .then(function (r) {
        if (!r.ok && strap) return agregar([tarjetero], secciones); // el strap se agotó: solo el tarjetero
        return r;
      })
      .then(function (r) {
        if (!r.ok) throw new Error((r.datos && (r.datos.description || r.datos.message)) || 'No se pudo agregar');
        if (window.ValizAsegurarRegalo) setTimeout(window.ValizAsegurarRegalo, 300);
        if (drawer && r.datos.sections && typeof drawer.renderContents === 'function') {
          var primero = r.datos.items ? r.datos.items[0] : r.datos;
          drawer.renderContents({ id: primero && primero.id, sections: r.datos.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        boton.disabled = false;
        boton.textContent = texto;
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      });
  });

  // ---------- Regalo automático (20-10-2026) ----------
  // Si el carro tiene un tarjetero y no tiene el strap de regalo, lo agrega con la
  // propiedad «Regalo: Con tu tarjetero» (se ve en carro, pago y pedido). Si el
  // tarjetero sale del carro, el regalo sale con él. El descuento automático de
  // Shopify deja el strap en $0. Escucha el aviso «el carro cambió» del tema.
  function config() {
    var n = document.querySelector('[data-valiz-regalo-config]');
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }
  var ocupado = false;
  function avisarCambio(carro) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'valiz-regalo', cartData: carro });
    }
    var burbuja = document.getElementById('cart-icon-bubble');
    if (burbuja && carro) {
      var n = burbuja.querySelector('.cart-count-bubble span');
      if (n) n.textContent = carro.item_count;
    }
  }
  function asegurarRegalo() {
    var c = config();
    if (!c || ocupado) return;
    ocupado = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carro) {
        var tarjeteros = 0, regalo = null;
        carro.items.forEach(function (it) {
          if (it.product_id === c.tarjetero) tarjeteros += it.quantity;
          if (it.variant_id === c.strap && it.properties && it.properties.Regalo) regalo = it;
        });
        // Oferta visible con el tarjetero ya en el carro: se esconde.
        if (tarjeteros > 0) document.querySelectorAll('[data-valiz-oferta-caja]').forEach(function (x) { x.hidden = true; });
        if (tarjeteros > 0 && !regalo && c.strapDisponible) {
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: c.strap, quantity: 1, properties: { Regalo: REGALO } }] }),
          }).then(function (r) { return r.ok ? fetch('/cart.js').then(function (x) { return x.json(); }).then(avisarCambio) : null; });
        }
        if (tarjeteros === 0 && regalo) {
          return fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: regalo.key, quantity: 0 }),
          }).then(function (r) { return r.json(); }).then(avisarCambio);
        }
        if (regalo && regalo.quantity > 1) {
          return fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: regalo.key, quantity: 1 }),
          }).then(function (r) { return r.json(); }).then(avisarCambio);
        }
      })
      .catch(function () {})
      .then(function () { ocupado = false; });
  }
  function suscribir() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === 'valiz-regalo') return;
        setTimeout(asegurarRegalo, 150);
      });
      return true;
    }
    return false;
  }
  function iniciar() {
    if (!suscribir()) setTimeout(function () { suscribir(); }, 800);
    asegurarRegalo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  window.ValizAsegurarRegalo = asegurarRegalo;
})();
